import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import GatsbyImage from "gatsby-image";
import Layout from "../components/Layout";
import WaveSVG from "../components/WaveSVG";
import { ABOUT_ROUTE } from "../constants";
import LayoutContainer from "../components/LayoutContainer";
import Button from "../components/Button";

export default () => {
  const data = useStaticQuery(graphql`
    query {
      content {
        aboutBannerMessage
        aboutFooterMessage
        aboutBody1
        aboutBody2
        aboutHeader1
        aboutHeader2
        aboutImage1 {
          contentImage {
            childImageSharp {
              fluid(maxWidth: 1000) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
    }
  `);
  const {
    aboutBannerMessage,
    aboutFooterMessage,
    aboutHeader1,
    aboutHeader2,
    aboutBody1,
    aboutBody2,
    aboutImage1,
  } = data.content;
  return (
    <Layout
      pageTitle="About Us"
      pageURL={ABOUT_ROUTE}
      pageDescription="Learn more about what makes The Silver Wolf Shops so great for our students and community"
    >
      <div className="about-us-header">
        <div className="about-us-banner" />
        <div className="about-us-header-content">
          <h1 className="font-bold text-5xl lg:text-6xl mb-4">ABOUT US</h1>
          <p>{aboutBannerMessage}</p>
        </div>
        <div className="svg-container">
          <WaveSVG />
        </div>
      </div>
      <LayoutContainer>
        <div className="m-auto max-w-screen-xl py-4">
          <div className="flex flex-wrap items-center flex-row-reverse">
            <div className="w-full lg:w-1/2 py-4 px-0 lg:px-4">
              <div className="content-container">
                <h3 className="font-bold text-3xl mb-2">{aboutHeader1}</h3>
                <div
                  dangerouslySetInnerHTML={{ __html: aboutBody1 }}
                  className="mb-12"
                />
                <h3 className="font-bold text-3xl mb-2">{aboutHeader2}</h3>
                <div
                  dangerouslySetInnerHTML={{ __html: aboutBody2 }}
                  className="mb-12"
                />
              </div>
            </div>
            <div className="w-full lg:w-1/2 py-4 px-0 lg:px-4">
              <div className="content-container">
                <div className="rounded shadow-lg overflow-hidden">
                  <GatsbyImage
                    fluid={aboutImage1.contentImage.childImageSharp.fluid}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="text-center py-12">
            <p className="mb-2">{aboutFooterMessage}</p>
            <div>
              <Button
                linkTo="/#products"
                variant="primaryContained"
                additionalClasses="w-48"
              >
                SHOP NOW
              </Button>
            </div>
          </div>
        </div>
      </LayoutContainer>
    </Layout>
  );
};
